let $ = require( "jquery" );
require('slick-carousel');

$(function() {

	let prevArrow = '<button class="slick-arrow slick-prev"><span class="visually-hidden">previous slide</span><svg aria-hidden="true" width="15" height="27" viewBox="0 0 15 27" xmlns="http://www.w3.org/2000/svg"><path d="M2.043 26.3.7 24.957l11.596-11.596L.7 1.704 2.043.3l12.939 13.061z" fill="currentColor" fill-rule="nonzero"/></svg></button>';
	let nextArrow = '<button class="slick-arrow slick-next"><span class="visually-hidden">next slide</span><svg aria-hidden="true" width="15" height="27" viewBox="0 0 15 27" xmlns="http://www.w3.org/2000/svg"><path d="M2.043 26.3.7 24.957l11.596-11.596L.7 1.704 2.043.3l12.939 13.061z" fill="currentColor" fill-rule="nonzero"/></svg></button>';
    let rowCarousels = $('.row-carousel');
    let carouselsWithImage = $('.collection-carousel-with-image');
    let iconCarousel = $('.icon-grid__carousel.enabled');
    let iconMobileCarousel = $('.icon-grid__mobile-carousel');
	let reviewsCarousels = $('.reviews-slider-object');
    let featureCarousels = $('.feature-carousel__items');
    let featureListCarousels = $('.features-list__items-m');
	
	// we have to count the items with js because the featured_color functionality changes the total count outputted vs num items in collection
	$('.row-carousel-items').each(function(){
		let count = $(this).find('.product-item').length;
		$(this)[0].style.setProperty('--column-count', count);
	});

    if(rowCarousels.length) {
        rowCarousels.each(function () {
            $(this).find('.carousel-object').slick({
                slidesToShow: 5,
                slidesToScroll: 1,
                prevArrow: prevArrow,
                nextArrow: nextArrow,
				infinite: false,
                responsive: [
                    {
                        breakpoint: 1400,
                        settings: {
                            slidesToShow: 4,
                        }
                    },
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 3,
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 1,
                        }
                    }
                ]
            });
        });
    }
    if(featureCarousels.length) {
        featureCarousels.each(function () {
            $(this).slick({
                slidesToShow: 4,
                slidesToScroll: 1,
                prevArrow: prevArrow,
                nextArrow: nextArrow,
				infinite: false
            });
        });
    }
    if(featureListCarousels.length) {
        featureListCarousels.each(function () {
            $(this).slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: true,
				arrows: false,
				autoplay: true,
				autoplaySpeed: 3000
            });
        });
    }

    if(carouselsWithImage.length) {
        carouselsWithImage.each(function () {
            $(this).find('.collection-carousel-with-image__object').slick({
                slidesToShow: 3,
                slidesToScroll: 1,
                prevArrow: prevArrow,
                nextArrow: nextArrow
            });
        });
    }

	if(iconCarousel.length) {
        iconCarousel.each(function () {
            $(this).slick({
                slidesToShow: 1,
                slidesToScroll: 1,
				arrows: false,
				fade: true,
				speed: 1200,
				autoplay: true,
				autoplaySpeed: 3000
            });
        });
    }
	if(iconMobileCarousel.length) {
        iconMobileCarousel.each(function () {
            $(this).slick({
                slidesToShow: 1,
                slidesToScroll: 1,
				arrows: false,
				fade: true,
				speed: 1200,
				autoplay: true,
				autoplaySpeed: 2000
            });
        });
    }


    if(reviewsCarousels.length) {
        reviewsCarousels.each(function () {

            $(this).slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                prevArrow: prevArrow,
                nextArrow: nextArrow,
				fade: true,
				autoplay: true,
				autoplaySpeed: 3000
            });

        });
    }


});
